import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import { UserLoggedModule } from "@/apps/UserLogged/store";
import { SharedModule } from "@/apps/shared/store";
import { AuthModule } from "@/apps/Auth/store";
import Permission from "./apps/Permission/meta";
import Teacher from "./apps/Teacher/meta";
import Student from "@/apps/Student/meta";
import Evaluation from "@/apps/Evaluation/meta";
import Report from "@/apps/Report/meta";

export const store = new Vuex.Store({
  modules: {
    UserLoggedModule,
    AuthModule,
    SharedModule,
    permission: Permission.module,
    teacher: Teacher.module,
    student: Student.module,
    evaluation: Evaluation.module,
    report: Report.module
  }
});

export default store;
